import React, { memo } from 'react';
import { View } from 'react-native';
import LinearGradient from 'react-native-linear-gradient';

import { Theme } from '@constants';

import { styles } from './styles';
import { MenuContainerProps } from './types';

export const MenuContainer = memo<MenuContainerProps>(({ useGradient, children }) => (
  <>
    <LinearGradient
      colors={[useGradient ? Theme.blackPearlBlue : Theme.transparent, Theme.transparent]}
      pointerEvents={'none'}
      style={styles.linearGradientWeb}
    />
    <View style={styles.topWeb}>
      <View style={styles.menu}>{children}</View>
    </View>
  </>
));
